import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/BlogPost.css";
import "../styles/Blog4.css";

function Blog10() {
  return (
    <>
      <Navbar />

      <article className="blog-post">

        {/* ── Breadcrumb ── */}
        <p className="blog-breadcrumb">
          <span>Technology</span>
          <span className="breadcrumb-divider">|</span>
          <span className="breadcrumb-section">Cybersecurity</span>
        </p>

        {/* ── Headline & dek ── */}
        <h1 className="blog-headline">
          Podcast Feature & Breaking Down Identity & Access Management
        </h1>

                <p className="blog-dek">
          A live podcast feature, Identiverse recap, and the basics of IAM everyone in tech should know
        </p>

        {/* ── Hero image ── */}
        <img
          src="iam-101.png"
          alt="Identity and Access Management 101"
          className="blog-hero-image"
          style={{
            width: "100%",
            maxWidth: "800px",
            display: "block",
            margin: "0 auto 24px",
            borderRadius: "8px",
          }}
        />

        {/* ── Share row ── */}
        <div className="blog-meta-row">
          <button
            className="blog-share-btn"
            onClick={() =>
              navigator.share?.({ title: document.title, url: window.location.href })
            }
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
            Share
          </button>
        </div>

        {/* ── Date + read time ── */}
        <p className="blog-dateline">August 24th 2026 &nbsp;|&nbsp; 5 min read</p>

        {/* ── Body copy ── */}
        <div className="blog-body">

          <p className="blog-drop-cap">
            It's now been about two months since Identiverse. It really
            doesn't seem like it was that long ago.
          </p>

          <p>
            I'm bringing this all up because the live episode of "Identity
            At The Center - Identity After Dark with Bravura Security" just
            dropped this week. It was a really neat experience to get to be
            a live audience member and then get featured on the episode
            around minute seventy. Most of all, getting pieces of insight
            from some of our leading identity experts and the encouragement
            from the community was special. Check out the episode here:{" "}
            <a
              href="https://www.identityatthecenter.com/listen"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.identityatthecenter.com/listen
            </a>{" "}
            (#442).
          </p>

          <p>
            Now you might be asking the question, what is Identity? What is
            Identity and Access Management (IAM)? What is Identiverse? Why
            does it all matter? The goal of this article is to provide you
            with some seeds of information to feed your cybersecurity
            knowledge base.
          </p>

          <p>
            So let's start with, what is Identiverse? Identiverse is an
            Identity and Access Management conference for professionals in
            the field. The conference is held in Las Vegas, Nevada, and
            they do it up. Big expo halls, fancy food, lots of people.
          </p>

          <p>
            Now — what's Identity and Access Management? Now that is a
            harder one to explain. But today, I will give you what I've
            learned when it comes to the basics of Identity and Access
            Management (IAM) and why it's a technical area that you should
            keep on your radar.
          </p>

          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "560px",
              aspectRatio: "16 / 9",
              margin: "0 auto 24px",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/MzvX_jBLfLE?si=0JY4MKkJY8QEgzTS"
              title="YouTube video player"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>

          <h2 className="blog-section-heading">
            Let's start with the basics: what is Identity and Access
            Management (IAM), really?
          </h2>

          <p>
            At its core, IAM is the set of policies, processes, and
            technologies that make sure the right people (or systems) have
            the right access to the right resources, at the right time.
            Sounds simple. It is not simple. Every company you've ever
            logged into — your bank, your email, your Netflix account — is
            running some version of IAM behind the scenes to figure out "is
            this really you, and what are you allowed to touch?"
          </p>

          <p>Here are the building blocks that make that possible.</p>

          <h3 className="blog-subsection-heading">1. Digital Identity</h3>

          <p>
            Before a system can decide what you're allowed to do, it has to
            know who you are. A digital identity is the collection of
            attributes that represent a person (or a device, or an
            application) inside a system. These are things like a
            username, an email address, a role, a department, a device ID.
            Every access decision starts here. No identity, no access. It's
            the foundation everything else is built on.
          </p>

          <h3 className="blog-subsection-heading">
            2. Authentication vs. Authorization
          </h3>

          <p>
            These two get mixed up constantly, but they're doing very
            different jobs.
          </p>

          <p>
            Authentication is proving you are who you say you are. Entering
            a password, scanning a fingerprint, tapping "approve" on a push
            notification — that's all authentication. It answers the
            question: "Is this really you?"
          </p>

          <p>
            Authorization happens after you're authenticated, and it
            answers a different question: "Okay, it's you — now what are
            you allowed to do?" This is what determines whether you can
            view a file, edit a record, or access an admin panel.
          </p>

          <p>
            The analogy I like is this: think of it like a concert; showing
            your ID at the door is authentication, and your ticket
            determining whether you sit in the nosebleeds or walk backstage
            is authorization.
          </p>

          <h3 className="blog-subsection-heading">3. Single Sign-On (SSO)</h3>

          <p>
            SSO lets a user log in once and gain access to multiple
            applications without having to re-enter credentials for each
            one. Instead of juggling twenty different passwords for twenty
            different tools, you authenticate once with a trusted identity
            provider (these would be Okta, Microsoft Entra ID, or Ping
            Identity, for example). That provider vouches for you across
            every connected app. It's a win for user convenience, and —
            when set up correctly — a win for security too. It's a win for
            your cybersecurity since it centralizes control instead of
            scattering credentials everywhere.
          </p>

          <h3 className="blog-subsection-heading">
            4. Multi-Factor Authentication (MFA)
          </h3>

          <p>
            MFA requires more than one form of proof before granting
            access. So MFA is typically something you (1) know (a
            password), something you (2) have (a phone or hardware token),
            or something you (3) are (a fingerprint or face scan). The
            logic behind MFA is as follows: passwords get stolen, phished,
            or reused constantly, so relying on just one factor is a weak
            bet. Requiring a second factor dramatically cuts down the odds
            that a stolen password alone can get an attacker in the door.
          </p>

          <h3 className="blog-subsection-heading">
            5. Privileged Access Management (PAM)
          </h3>

          <p>
            What you need to understand here is that not all accounts are
            created equal. Some accounts — admin accounts, service
            accounts, accounts that can touch sensitive infrastructure —
            carry way more risk than a standard user login. PAM is the
            discipline of tightly controlling, monitoring, and limiting
            access for these high-privilege accounts. PAM often works
            through things like just-in-time access (granting elevated
            permissions only when needed, for a limited time) and session
            recording.
          </p>

          <p>
            The analogy I'll use here is this: it's the difference between
            giving someone a key to their own apartment versus giving them
            the master key to every door within the apartment building. You
            want there to be a difference (known as extra guardrails).
          </p>

          <p>
            Together, these pieces form the backbone of IAM: knowing who
            someone is, proving it, deciding what they can do, making
            access convenient without making it reckless, and locking down
            the accounts that matter most.
          </p>

        </div>
      </article>

      <Footer />
    </>
  );
}

export default Blog10;